// src/theme.js
const KEY = "theme"; // "dark" | "light"

export function getTheme() {
  const t = localStorage.getItem(KEY);
  return t === "light" ? "light" : "dark";
}

export function applyTheme(theme) {
  const t = theme === "light" ? "light" : "dark";
  document.documentElement.setAttribute("data-theme", t);
  localStorage.setItem(KEY, t);
  return t;
}

export function initTheme() {
  return applyTheme(getTheme());
}

export function toggleTheme() {
  return applyTheme(getTheme() === "light" ? "dark" : "light");
}